import { render, staticRenderFns } from "./EHSModal.vue?vue&type=template&id=6ebb93d4&scoped=true&"
import script from "./EHSModal.vue?vue&type=script&lang=js&"
export * from "./EHSModal.vue?vue&type=script&lang=js&"
import style0 from "./EHSModal.vue?vue&type=style&index=0&id=6ebb93d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebb93d4",
  null
  
)

export default component.exports